module.exports = __webpack_public_path__ + "img/close-r-k.c312ba5e.svg";